import { LaneEntity } from './entities/LaneEntity';
import { LaneEntitySpine } from './entities/LaneEntitySpine';
import LaneEntityImageBase from './LaneEntityImageBase';

export class EntityFactory {
  public static entitiesToSpawn: typeof LaneEntitySpine[] = [];

  protected scene: Phaser.Scene;
  protected isInitialised: boolean;
  protected groups: Map<typeof LaneEntitySpine, Phaser.GameObjects.Group>;

  constructor(scene: Phaser.Scene) {
    this.scene = scene;
    this.isInitialised = false;

    this.groups = new Map();
  }

  public init() {
    // if (this.isInitialised) return;

    this.groups = new Map();

    EntityFactory.entitiesToSpawn.forEach((entityClass) => {
      if (!this.groups.has(entityClass)) {
        let group = this.scene.add.group([], { classType: entityClass });
        this.groups.set(entityClass, group);

        // for (let i = 0; i < 10; i++) {
        //   group.create(-1000, 0, undefined, undefined, false, false);
        // }
      }
    });

    // this.isInitialised = true;
  }

  // public makeEntity<T extends LaneEntityImageBase>(entityClass: typeof LaneEntityImageBase, x: number, y: number): T | undefined {
  //   if (entityClass) {
  //     let group = this.groups.get(entityClass) as Phaser.GameObjects.Group;
  //     let entity = group.get() as T;
  //     entity.init();
  //     entity.reset();
  //     entity.x = x;
  //     entity.y = y;

  //     return entity;
  //   }
  // }

  public makeEntity<T extends LaneEntitySpine>(entityClass: typeof LaneEntitySpine, x: number, y: number): T | undefined {
    if (entityClass) {
      let group = this.groups.get(entityClass) as Phaser.GameObjects.Group;
      let entity = group.get() as T;
      entity.init();
      entity.reset();
      entity.x = x;
      entity.y = y;

      return entity;
    }
  }
}
